import styled from 'styled-components'

export const AnalysisAdvancedFilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`

export const AnalysisAdvancedFilterActiveFiltersSummary = styled.div`
  padding: 16px 20px;
  background: ${({ theme }) => theme.colors.background.secondary + '50'};
  border-radius: 8px;
  margin-bottom: 16px;
`

export const AnalysisAdvancedFilterTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

export const AnalysisAdvancedFilterTag = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background: ${({ theme }) => theme.colors.background.secondary};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.primary};
  transition: all 0.2s ease;

  svg {
    width: 14px;
    height: 14px;
    color: ${({ theme }) => theme.colors.text.secondary};
  }

  span {
    max-width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    padding: 0;
    margin-left: 2px;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.text.tertiary};
    transition: color 0.2s ease;

    &:hover {
      color: ${({ theme }) => theme.colors.danger};
    }

    svg {
      width: 12px;
      height: 12px;
    }
  }

  &:hover {
    background: ${({ theme }) => theme.colors.background.secondary};
    border-color: ${({ theme }) => theme.colors.border.default};
  }
`

export const AnalysisAdvancedFilterClearButton = styled.button`
  background: none;
  border: none;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.danger};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.danger + '20'};
    border-radius: 4px;
  }
`

export const AnalysisAdvancedFilterSection = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};

  &:last-child {
    border-bottom: none;
  }
`

export const AnalysisAdvancedFilterSectionTitle = styled.button<{
  $expanded: boolean
}>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: none;
  border: none;
  cursor: pointer;
  transition: background 0.2s ease;
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};

  &:hover {
    background: ${({ theme }) => theme.colors.background.secondary + '50'};
  }

  span {
    font-size: 13px;
  }

  svg {
    width: 16px;
    height: 16px;
    color: ${({ theme }) => theme.colors.primary};
    transition: transform 0.2s ease;
  }
`

export const AnalysisAdvancedFilterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  padding: 0 20px 20px;
`

export const AnalysisAdvancedFilterField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const AnalysisAdvancedFilterLabel = styled.label`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.secondary};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

export const AnalysisAdvancedFilterRangeInputGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  input {
    flex: 1;
    min-width: 0;
  }
`

export const AnalysisAdvancedFilterRangeSeparator = styled.div`
  width: 12px;
  height: 1px;
  background: ${({ theme }) => theme.colors.border.light};
  flex-shrink: 0;
`

export const AnalysisAdvancedFilterQuickFilters = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 0 20px 16px;
`

export const AnalysisAdvancedFilterQuickFilterChip = styled.button<{
  $active?: boolean
  $small?: boolean
}>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: ${({ $small }) => ($small ? '4px 12px' : '6px 14px')};
  background: ${({ theme, $active }) =>
    $active
      ? theme.colors.primaryLight + '20'
      : theme.colors.background.secondary};
  color: ${({ theme, $active }) =>
    $active ? theme.colors.primary : theme.colors.text.primary};
  border: 1px solid
    ${({ theme, $active }) =>
      $active ? theme.colors.primary : theme.colors.border.light};
  border-radius: 20px;
  font-size: ${({ $small }) => ($small ? '12px' : '13px')};
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    background: ${({ theme, $active }) =>
      $active
        ? theme.colors.primaryLight + '30'
        : theme.colors.background.tertiary};
    border-color: ${({ theme, $active }) =>
      $active ? theme.colors.primary : theme.colors.border.default};
    transform: translateY(-1px);
    box-shadow: ${({ theme }) => theme.shadows.sm};
  }

  &:active {
    transform: translateY(0);
  }

  svg {
    width: 14px;
    height: 14px;
  }
`
